<template>
  <div class="trix-start">
    <input id="trix" type="hidden" :name="name" :value="value">
    <trix-editor placeholder="Write a reply..." ref="trix" input="trix"></trix-editor>
  </div>
</template>

<script>
  /* eslint-disable indent,no-new,no-undef */
  import Trix from 'trix'

  export default {
    name: 'wysiwyg',
    components: {
      Trix
    },
    props: ['name', 'value', 'shouldClear'],
    watch: {
      shouldClear () {
        this.$refs.trix.value = ''
      }
    },
    mounted () {
      this.$refs.trix.addEventListener('trix-change', e => {
        this.$emit('input', e.target.innerHTML)
      })
      this.$refs.trix.addEventListener('trix-initialize', e => {
        // add Unordered List to first button group
        e.target.toolbarElement.querySelector('.trix-button-group.trix-button-group--text-tools')
          .appendChild(e.target.toolbarElement.querySelector('.trix-button.trix-button--icon.trix-button--icon-bullet-list'))
        // add Numbered List to first button group
        e.target.toolbarElement.querySelector('.trix-button-group.trix-button-group--text-tools')
          .appendChild(e.target.toolbarElement.querySelector('.trix-button.trix-button--icon.trix-button--icon-number-list'))
        // delete second and third button group
        e.target.toolbarElement.querySelector('.trix-button-group.trix-button-group--block-tools').remove()
        e.target.toolbarElement.querySelector('.trix-button-group.trix-button-group--history-tools').remove()
        e.target.toolbarElement.querySelector('.trix-button-group.trix-button-group--file-tools').remove()

        // remove unwanted buttons from the group
        e.target.toolbarElement.querySelector('.trix-button.trix-button--icon.trix-button--icon-strike').remove()
        e.target.toolbarElement.querySelector('.trix-button.trix-button--icon.trix-button--icon-link').remove()
        e.target.toolbarElement.querySelector('.trix-button-row').style.backgroundColor = '#e7e5e5'

        // add margin top to toolbar and remove button borders
        e.target.toolbarElement.querySelector('.trix-button-group.trix-button-group--text-tools').style.marginTop = '10px'
        e.target.toolbarElement.querySelector('.trix-button-group.trix-button-group--text-tools').style.border = 'none'
        e.target.toolbarElement.querySelector('.trix-button.trix-button--icon.trix-button--icon-bold').style.border = 'none'
        e.target.toolbarElement.querySelector('.trix-button.trix-button--icon.trix-button--icon-bold').style.color = '#8a8c91'
        e.target.toolbarElement.querySelector('.trix-button.trix-button--icon.trix-button--icon-italic').style.border = 'none'
        e.target.toolbarElement.querySelector('.trix-button.trix-button--icon.trix-button--icon-italic').style.color = '#8a8c91'
        e.target.toolbarElement.querySelector('.trix-button.trix-button--icon.trix-button--icon-bullet-list').style.border = 'none'
        e.target.toolbarElement.querySelector('.trix-button.trix-button--icon.trix-button--icon-bullet-list').style.color = '#8a8c91'
        e.target.toolbarElement.querySelector('.trix-button.trix-button--icon.trix-button--icon-number-list').style.border = 'none'
        e.target.toolbarElement.querySelector('.trix-button.trix-button--icon.trix-button--icon-number-list').style.color = '#8a8c91'
      })
    }
  }
</script>

<style>
  trix-editor {
    background-color: #fff;
    border-radius: 0;
    border: none;
    color: #8a8c91;
  }

  trix-editor ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }
  trix-editor ol {
    margin: 0;
    padding: 0;
    list-style-position: inside;
  }
  trix-editor ul li, trix-editor ol li {
    margin: 0;
    padding: 0;
  }
  trix-editor ul li::before {
    content: '•';
    margin-right: 10px;
  }

  .trix-start {
    margin-top: 1rem;
    margin-bottom: 1rem;
    border: 1px solid #8a8c91;
  }

</style>



// WEBPACK FOOTER //
// src/components/Wysiwyg.vue